/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Liquidity provider update request
 */
export interface LiquidityProviderUpdateRequest {
  name: string;
  shortName: string;
  participateInPriceProtection: boolean;
  supportPriceImprovement: boolean;
  routeOnlyFullOrder: boolean;
  id: number;
  /**
   * If false - sets lp as inactive. Default - active
   */
  active: boolean;
}
